import React, { useContext as useContextCore } from 'react'
import { queries } from './graphql'
import { useDocument } from '@ztechapps/common.hook'
import { PublicationStatusEnum } from '@ztechapps/common.contract'
import { useParams } from 'react-router-dom'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const params = useParams()
  const { _id } = params ?? {}

  const documentResult = useDocument({
    ...queries.singleConfig,
    filter: { _id, status: { $in: [PublicationStatusEnum.Active, PublicationStatusEnum.Internal] } },
  })

  return <CoreProvider value={{ ...props, ...documentResult }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
